"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ModelUsageUnit = void 0;
// disable lint as this is exported and used in packages
var ModelUsageUnit;
(function (ModelUsageUnit) {
    ModelUsageUnit["Characters"] = "CHARACTERS";
    ModelUsageUnit["Tokens"] = "TOKENS";
    ModelUsageUnit["Seconds"] = "SECONDS";
    ModelUsageUnit["Milliseconds"] = "MILLISECONDS";
    ModelUsageUnit["Images"] = "IMAGES";
    ModelUsageUnit["Requests"] = "REQUESTS";
})(ModelUsageUnit || (exports.ModelUsageUnit = ModelUsageUnit = {}));
